/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'
import moment from 'moment'

export default class DateField extends PureComponent {
  render() {
    const { label, value, onChange } = this.props

    const formattedDate = moment(parseInt(value, 10)).format('YYYY-MM-DD')

    return (
      <Form.Field required>
        <label>{label}</label>
        <Input
          required
          type="date"
          value={formattedDate}
          onChange={e => onChange(e.target.value)}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/promotions/fields/dateField.js